import { NavLink, Link } from 'react-router-dom'
import { useI18n } from '../lib/i18n'

export function Nav() {
  const { t, lang, setLang } = useI18n()
  const items = [
    { to: '/features', label: t('nav.features') },
    { to: '/try-it', label: t('nav.try-it') },
    { to: '/status', label: t('nav.status') },
    { to: '/downloads', label: t('nav.downloads') },
    { to: '/guide', label: t('nav.guide') },
    { to: '/prirucka', label: t('nav.prirucka') },
    { to: '/scenarios', label: t('nav.scenarios') },
    { to: '/docs', label: t('nav.docs') },
  ]

  return (
    <header className="sticky top-0 z-50 backdrop-blur bg-ground/95 border-b border-rule">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 h-16 flex items-center gap-7">
        <div className="flex items-center gap-3 shrink-0">
          <a href="https://xlabproject.net" title="Přehled projektů XLAB">
            <img src="/x_logo_white.png" alt="XLAB" className="h-4 w-auto opacity-90" />
          </a>
          <span className="w-px h-[22px] bg-rule" aria-hidden="true" />
          <Link to="/" className="flex items-center font-display font-extrabold text-[19px] leading-none text-ink">
            Show
            <img src="/x_symbol_white.png" alt="✕" className="h-[0.6em] ml-1.5 w-auto" />
          </Link>
        </div>
        <nav className="ml-auto hidden lg:flex items-center gap-6">
          {items.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-4 shrink-0 ml-auto lg:ml-0">
          <button
            onClick={() => setLang(lang === 'cs' ? 'en' : 'cs')}
            className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted hover:text-ink transition-colors px-2 py-1 border border-rule"
            aria-label="Toggle language"
          >
            {lang === 'cs' ? 'EN' : 'CS'}
          </button>
          <a
            href="mailto:hello@xlabproject.net?subject=ShowX%20dev%20preview%20cohort&body=Hi%20XLAB%2C%0A%0AI'd%20like%20a%20seat%20in%20the%20ShowX%20dev%20preview%20cohort.%0A%0AWho%20I%20am%3A%20%0AVenue%20%2F%20role%3A%20%0AWhat%20I%20want%20to%20see%20from%20ShowX%3A%20%0A%0AThanks!"
            className="font-sans font-semibold text-[12px] uppercase tracking-[0.15em] text-accent hover:text-accent-deep transition-colors"
          >
            {t('nav.preview')}
          </a>
        </div>
      </div>
    </header>
  )
}
